module.exports = __webpack_public_path__ + "img/patron-amarillo-fondo.9ac0b18d.svg";